class TermsCheckbox extends HTMLElement {
  connectedCallback() {
      var form = document.querySelector('.quick-cart__form');
      if (form) {
        var termsCheckbox = form.querySelector("#cart_terms");
        var invoiceCheckbox = form.querySelector("#cart_invoice");
        var submitButton = form.querySelector('button[name="checkout"]');

        if (termsCheckbox && submitButton) {
          termsCheckbox.addEventListener('change', () => {
            submitButton.disabled = !termsCheckbox.checked;
            if (termsCheckbox.checked) {
              CartInvoice.handleCheckout(termsCheckbox.closest('form').querySelector('cart-invoice-form'));
            }
          });
          invoiceCheckbox.addEventListener('change', () => {
            CartInvoice.handleCheckout(invoiceCheckbox.closest('form').querySelector('cart-invoice-form'));
          });
        }
      }
  }
}

customElements.define("cart-terms-check", TermsCheckbox);
